<template id="search-form">
	<div class="subnav__buscar">
		<input type="submit" value="Enviar" name="">
		<input type="text" name="search" placeholder="Introduzca su búsqueda…" v-on:keyup.enter="doSearch"
        v-model="searchTerm">
	</div>
</template>



<script>
export default {
	mounted: function() {
	},
	methods: {
		doSearch: function() {
			const vm = this;
			//console.log('____'+vm.searchTerm);
			vm.$router.push(
            {   name: 'search', 
                params: {    
                    s: vm.searchTerm
                }}); 
        
		}
	}
};
</script>



// WEBPACK FOOTER //
// _buscador.vue?5259cd67